import React, { Component } from "react";
import PropTypes from "prop-types";
import {
  Row,
  Col,
  Button,
  FormGroup,
  FormControl,
  ControlLabel,
  Checkbox,
  Alert,
  FieldGroup,
  Image,
  Badge,
  Tooltip,
  Form,
  Modal,
} from "react-bootstrap";
import { withRouter } from "react-router";
import { connect } from "react-redux";
import { bindActionCreators, compose } from "redux";
import { createBrowserHistory } from "history";
import { NewBreadcrumb as BreadcrumbComponent } from "../../../components";
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
import ReactHtmlParser from "react-html-parser";
import "../../../style/subAdmin/SubAdmin.scss";
import isEmpty from "lodash.isempty";
import {
  getDealDetail,
  getAllCategory,
  editProductList,
  addDealLocation,
  deleteImage,
  updateAttribute,
  uploadImage,
  updateDealImgOrdering
} from "../../../redux/actions/dealActions";
import {
  getSiteCity
} from "../../../redux/actions/frontActions";
import { get_merchant_location_details } from "../../../redux/actions/merchantActions";
import { renderAlert, clearAlert } from "../../../redux/actions/alertsActions";
import moment from "moment";
import CKEditor from "react-ckeditor-component";

import DateTimePicker from "react-datetime-picker";
import "../../../style/react-datetimepicker.scss";

import "../../../style/tooltip-top.scss";
import DealAttribute from "./DealAttribute";
import {aclUtil} from "../../util"

import ReactCrop from 'react-image-crop';
import 'react-image-crop/dist/ReactCrop.css';
const history = createBrowserHistory();

const HorizontalLine = ({}) => <hr />;

const propTypes = {
  getDealDetail: PropTypes.array.isRequired,
  editProductList: PropTypes.array.isRequired,
  get_merchant_location_details: PropTypes.array.isRequired
};

let cityItems = [],
  isLoading = "false",
  isProcess = "false",
  preview = [],
  xCoordinate = {},
  imageAlt = [],
  yCoordinate = {};


// a little function to help us with reordering the result
const reorder = (list, startIndex, endIndex) => {
  const result = Array.from(list);
  const [removed] = result.splice(startIndex, 1);
  result.splice(endIndex, 0, removed);

  return result;
};

const grid = 8;

const getDefaultBackground = (index) => {
  return index == 0 ? 'lightcoral' : 'lightgrey';
}

const getItemStyle = (isDragging, draggableStyle, index) => ({
  // some basic styles to make the items look a bit nicer
  userSelect: 'none',
  padding: grid * 2,
  margin: `0 ${grid}px 0 0`,

  position: 'relative',

  // change background colour if dragging
  background: isDragging ? 'lightgreen' : getDefaultBackground(index),

  // styles we need to apply on draggables
  ...draggableStyle,
});

const getListStyle = isDraggingOver => ({
  background: isDraggingOver ? 'lightblue' : '#efefef',
  display: 'flex',
  padding: grid,
  overflow: 'auto',
});

class EditProduct extends Component {
  static contextTypes = {
    router: PropTypes.object
  }
  constructor(props) {
    const editLink = props.match.params.dealID && `editProduct/${props.match.params.dealID}`
    super(props);
    this.state = {
      menuKey: 'EDIT_PRODUCTS_DETAILS',
      path: ["Home", "Manage Product Details", "Edit Product Details"],
      links: ["home", "productList",editLink],
      startDate: moment(),
      startDateTime: "",
      show: false,
      catList: [],
      highlights: "",
      writeUp: "",
      termsAndConditions: "",
      whyWeLoveIt: "",
      expiryDateTime: "",
      isInfinite: "0",
      dealText: "",
      french_dealText: "",
      fontSize: "",
      shortTitle: "",
      useProdName: "",
      prodName: "",
      useMerchantDefaultTax: "1",
      willCall: "0",
      showPurchasedCount: "0",
      showQuantityLeft: "no",
      allowCouponCodes: "1",
      marketingPixelUrl: "",
      //freeShipping: 0,
      //shippingAmount: 0,
      //shippingAmountMerchant: 0,
      //shippingAmountAdmin: 0,
      isTaxable: "0",
      storeCredit: "0",
      checkoutNotes: "",
      redeemedAtCall: "0",
      productPageUrl: "0",
      allowPaypal: "0",
      isPrivate: "0",
      productHideLocation: "1",
      paused: "0",
      usePauseTimer: "0",
      endPauseDateTime: "",
      startPauseDateTime: "",
      displayTimer: "0",
      timerStartInHour: "0",
      shipable: "0",
      catID: [],
      dealID: "",
      mainDealText: "",
      locID: "",
      locationID: [],
      quantity: [],
      locationQuantity: "",
      viewData: [],
      isActive: [],
      disabled: false,
      submitValue: "Save",
      alertMessage: "",
      url: "",
      dealImages: "",
      startDateTimeError: "startDateTime-datepicker",
      startDateTimeTooltipError: "",
      expiryDateTimeTooltipError: "",
      expiryDateTimeError: "startDateTime-datepicker",
      startPauseDateTimeError: "startDateTime-datepicker",
      endPauseDateTimeError: "startDateTime-datepicker",
      startPauseDateTimeTooltipError: "",
      endPauseDateTimeTooltipError: "",
      dealAttribute: "",
      dealAttributeError: false,
      dealAttributeErrors: [],
      shippingAmountMerchantError: "",
      shippingAmountAdminError: "",
      shippingAmountError: "",
      highlightFirst:"",
      highlightSecond:"",
      highlightThird:"",
      highlightFourth:"",
      selectedFile: [],
      offer_url: '',
      offer_meta_title: '',
      french_offer_meta_title: '',
      offer_description: '',
      french_offer_description: '',
      location: '',
      locationQuantity: '',
      openIamgeAttribute: false,
      imageAlt: [],
      crompImagePopup: false,
      src: null,
      crop: {
        width: 80,
        height: 80,
        x: 10,
        y: 10,
      },
      dealLocation: [],
      cityList: '',
      marketID: [],
      all_city: 0,
      all_cities: 0,
      french_shortTitle: '',
      frenchhighlightFirst:"",
      frenchhighlightSecond:"",
      frenchhighlightThird:"",
      frenchhighlightFourth:"",
      french_checkoutNotes:"",
      french_highlights:"",
      french_prodName: "",
      french_termsAndConditions: "",
      french_writeUp: "",
      multi_lang: 'no',
      requireLocation:true,
    };

    this.highlights = this.highlights.bind(this);
    this.writeUp = this.writeUp.bind(this);
    this.french_writeUp = this.french_writeUp.bind(this);
    this.termsAndConditions = this.termsAndConditions.bind(this);
    this.whyWeLoveIt = this.whyWeLoveIt.bind(this);

    this.handleCategory = this.handleCategory.bind(this);
    this.isInfinite = this.isInfinite.bind(this);
    this.handleQuantity = this.handleQuantity.bind(this);
    this.handleAddLocation = this.handleAddLocation.bind(this);
    this.handleRequireLocation = this.handleRequireLocation.bind(this);

    this.validate = this.validate.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleUpdateDates = this.handleUpdateDates.bind(this);

    // Alert
    this.handleDismiss = this.handleDismiss.bind(this);
    this.handleShow = this.handleShow.bind(this);

    this.setShippingAttrRequired = this.setShippingAttrRequired.bind(this);
    this.setDealAttributeError = this.setDealAttributeError.bind(this);

    this.handleFormData = this.handleFormData.bind(this);
    this.french_termsAndConditions = this.french_termsAndConditions.bind(this);

    this.onDragEnd = this.onDragEnd.bind(this);
  }

  closeAttribute = () => {
    this.setState({
      openIamgeAttribute: false, 
      attributeImg: '', 
      img_text: '' , 
      img_alt_text: '', 
      img_desc: '', 
      img_textError: '' , 
      img_alt_textError: '', 
      img_descError: '', 
      imageId: '',
      imageType: '',
    });
  }

   onDragEnd(result) {
    // dropped outside the list
    if (!result.destination) {
      return;
    }

    const dealImages = reorder(
      this.state.dealImages,
      result.source.index,
      result.destination.index
    );
    const orderedJSON = dealImages.map(function(dealImg,idnx) {
      return {
        id: dealImg.id,
        order: idnx+1,
      } 
    });
    this.props.updateDealImgOrdering({orderedJSON});
    this.setState({
      dealImages,
    });
  }

  openAttribute = (e) => {
    let image = e.target.attributes.getNamedItem("data-img").value;
    let title = e.target.attributes.getNamedItem("data-text").value;
    let alt = e.target.attributes.getNamedItem("data-alt").value;
    let desc = e.target.attributes.getNamedItem("data-desc").value;
    let id = e.target.attributes.getNamedItem("data-id").value;
    let imageType = e.target.attributes.getNamedItem("data-imagestatus").value;
    this.setState({
      openIamgeAttribute: true, 
      attributeImg: image, 
      img_text: title , 
      img_alt_text: alt, 
      img_desc: desc, 
      imageId: id,
      imageType: imageType,
    });
  }

  validateAttributeForm = (e) => {
    let isValid = true;

    if(this.state.img_alt_text === 'null'){
      isValid = false;
      this.setState({img_alt_textError: 'red'});
    }

    if(this.state.img_text === 'null'){
      isValid = false;
      this.setState({img_textError: 'red'});
    }

    if(this.state.img_desc === 'null'){
      isValid = false;
      this.setState({img_descError: 'red'});
    }

    return isValid;
  }
  saveImageAttribute = (e) => {
    e.preventDefault();
    let valid = this.validateAttributeForm();
    if(valid){
      if(this.state.imageType == 'new') {
        if (!Array.isArray(imageAlt[this.state.imageId])) {
          imageAlt[this.state.imageId] = [];
        }
        if(isEmpty(imageAlt[this.state.imageId])){

          imageAlt[this.state.imageId].push({
            img_alt_text:  this.state.img_alt_text,
            img_text: this.state.img_text,
            img_desc: this.state.img_desc,
          });

        }else{
          imageAlt[this.state.imageId][0].img_alt_text = this.state.img_alt_text;
          imageAlt[this.state.imageId][0].img_text = this.state.img_text;
          imageAlt[this.state.imageId][0].img_desc = this.state.img_desc;
        }
        
        this.setState({imageAlt: imageAlt});
        this.closeAttribute();
      }else{
        const constData = {
          id: this.state.imageId,
          img_alt_text: this.state.img_alt_text,
          img_text: this.state.img_text,
          img_desc: this.state.img_desc,
        }
        isLoading = "true";
        this.props.updateAttribute(constData);
      }
    }
  }

  onChangeStartDate = date => {
    this.setState({ startDateTime: date });
    this.updateChildDeals(
      "startDateTime",
      moment(date).format("YYYY-MM-DD HH:mm:ss"),
      this.props.index
    );
  };

  onChangeExpiryDate = date => {
    this.setState({ expiryDateTime: date });
    this.updateChildDeals(
      "expiryDateTime",
      moment(date).format("YYYY-MM-DD HH:mm:ss"),
      this.props.index
    );
  };


  onChangeStartDate = date => {
    if (
      this.state.startDateTimeTooltipError ||
      this.state.expiryDateTimeError
    ) {
      this.setState({
        startDateTimeError: "startDateTime-datepicker",
        expiryDateTimeError: "startDateTime-datepicker",
        startDateTimeTooltipError: "",
        expiryDateTimeTooltipError: ""
      });
    }
    this.setState({ startDateTime: date });
    if (this.state.expiryDateTime) {
      const startDate = moment(date).format("YYYY-MM-DD");
      const expiryDate = moment(this.state.expiryDateTime).format("YYYY-MM-DD");
      if (startDate > expiryDate) {
        this.setState({
          startDateTimeError: "startDateTime-datepicker-error",
          startDateTimeTooltipError:
            "Start date should be less than expiry date!"
        });
      }
    }
  };

  onChangeExpiryDate = date => {
    if (
      this.state.startDateTimeTooltipError ||
      this.state.expiryDateTimeError
    ) {
      this.setState({
        startDateTimeError: "startDateTime-datepicker",
        expiryDateTimeError: "startDateTime-datepicker",
        startDateTimeTooltipError: "",
        expiryDateTimeTooltipError: ""
      });
    }
    this.setState({ expiryDateTime: date });
    if (this.state.startDateTime) {
      const startDate = moment(this.state.startDateTime).format("YYYY-MM-DD");
      const expiryDate = moment(date).format("YYYY-MM-DD");
      if (startDate > expiryDate) {
        this.setState({
          expiryDateTimeError: "startDateTime-datepicker-error",
          expiryDateTimeTooltipError:
            "Expiry date should be greater than start date!"
        });
      }
    }
  };
  onChangeStartPauseDateTime = date => {
    this.setState({ startPauseDateTime: date });
    if (
      this.state.startPauseDateTimeError ||
      this.state.endPauseDateTimeError
    ) {
      this.setState({
        startPauseDateTimeError: "startDateTime-datepicker",
        endPauseDateTimeError: "startDateTime-datepicker",
        startPauseDateTimeTooltipError: "",
        endPauseDateTimeTooltipError: ""
      });
    }
    if (this.state.endPauseDateTime) {
      const startDate = moment(date).format("YYYY-MM-DD");
      const expiryDate = moment(this.state.endPauseDateTime).format(
        "YYYY-MM-DD"
      );
      if (startDate > expiryDate) {
        this.setState({
          startPauseDateTimeError: "startDateTime-datepicker-error",
          startPauseDateTimeTooltipError:
            "Start Pause date should be less than end pause date!"
        });
      }
    }
  };
  onChangeEndPauseDateTime = date => {
    this.setState({ endPauseDateTime: date });
    if (
      this.state.startPauseDateTimeError ||
      this.state.endPauseDateTimeError
    ) {
      this.setState({
        startPauseDateTimeError: "startDateTime-datepicker",
        endPauseDateTimeError: "startDateTime-datepicker",
        startPauseDateTimeTooltipError: "",
        endPauseDateTimeTooltipError: ""
      });
    }
    if (this.state.startPauseDateTime) {
      const startDate = moment(this.state.startPauseDateTime).format(
        "YYYY-MM-DD"
      );
      const expiryDate = moment(date).format("YYYY-MM-DD");
      if (startDate > expiryDate) {
        this.setState({
          endPauseDateTimeError: "startDateTime-datepicker-error",
          endPauseDateTimeTooltipError:
            "End pause date should be greater than start pause date!"
        });
      }
    }
  };
  onStartDateTimeBlur = e => {
    e.preventDefault();
    const startDate = moment(this.state.startDateTime).format("YYYY-MM-DD");
    const expiryDate = moment(this.state.expiryDateTime).format("YYYY-MM-DD");
    if (this.state.expiryDateTime && this.state.startDateTime) {
      if (startDate > expiryDateTime) {
        this.setState({
          startDateTimeError: "startDateTime-datepicker-error",
          startDateTimeTooltipError: "Start date should be less than end date!"
        });
      }
    }
  };

  onExpiryDateTimeBlur = e => {
    e.preventDefault();
    const startDate = moment(this.state.startDateTime).format("YYYY-MM-DD");
    const expiryDate = moment(this.state.expiryDateTime).format("YYYY-MM-DD");
    if (this.state.startDateTime && this.state.expiryDateTime) {
      if (startDate > expiryDateTime) {
        this.setState({
          expiryDateTimeError: "red",
          expiryDateTimeTooltipError:
            "Expiry date should be greater than start date!"
        });
      }
    }
  };

  

  handleDismiss() {
    this.setState({ show: false });
  }

  removeImage(e, index) {
    isLoading = "true";
    this.props.deleteImage(e);
    let preview = this.state.dealImages;
    preview.splice(index,1);
    this.setState({ dealImages: preview });
    isLoading = "false";
  }

  handleFormData(e) {   
    if (e.target.files && e.target.files.length > 0) {
      const reader = new FileReader()
      reader.addEventListener(
        'load',
        () =>
          this.setState({
            src: reader.result,
          }),
        false
      )
      reader.readAsDataURL(e.target.files[0]);
      this.setState({ crompImagePopup: true, crop: {
        aspect: 16/9,
        width: 100,
        height: 100,
        x: 0,
        y: 0,
      } });
      e.target.value = null;
    }
  }

  onImageLoaded = (image, pixelCrop) => {
    this.imageRef = image;
  };

  onCropComplete = (crop, pixelCrop) => {
    this.makeClientCrop(crop, pixelCrop);
  };

  onCropChange = crop => {
    this.setState({ crop });
  };

  async makeClientCrop(crop, pixelCrop) {
    if (this.imageRef && crop.width && crop.height) {
      const croppedImageUrl = await this.getCroppedImg(
        this.imageRef,
        pixelCrop,
        'newFile.jpeg',
      );
      this.setState({ croppedImageUrl });
    }
  }

  getCroppedImg(image, pixelCrop, fileName) {
    const canvas = document.createElement('canvas');
    canvas.width = pixelCrop.width;
    canvas.height = pixelCrop.height;
    const ctx = canvas.getContext('2d');

    ctx.drawImage(
      image,
      pixelCrop.x,
      pixelCrop.y,
      pixelCrop.width,
      pixelCrop.height,
      0,
      0,
      pixelCrop.width,
      pixelCrop.height,
    );

    // As Base64 string
    const base64Image = canvas.toDataURL('image/jpeg')
    this.setState({uploadImage: base64Image, imgWidth: pixelCrop.width, imgHeight: pixelCrop.height});

    return new Promise((resolve, reject) => {
      canvas.toBlob(blob => {
        if (!blob) {
          console.error('Canvas is empty');
          return;
        }
        blob.name = fileName;
        window.URL.revokeObjectURL(this.fileUrl);
        this.fileUrl = window.URL.createObjectURL(blob);
        resolve(this.fileUrl);
      }, 'image/jpeg');
    });
  }

  closeCropPopup(){
    this.setState({ crompImagePopup: false, src: '', crop: '',  uploadImage: ''});
  }

  saveCropImage = () => {
    if(this.state.imgWidth >= 720 && this.state.imgHeight >= 520){
      isLoading = "true";
      const sendImage = {
        base64img : (this.state.uploadImage) ? this.state.uploadImage : this.state.src,
        dealID: this.props.match.params.dealID,
      }

      this.props.uploadImage(sendImage);
    }else{
      alert('The image size must be greater than or equal to 924px X 520px');
    }
  }

  handleShow() {
    this.setState({ show: true });
  }

  handleMarketRun = (e) => {
    const marketID = this.state.marketID;

    let index;
    let dealMarket;

    if (e.target.checked) {
      this.setState({ marketError: "" });
      marketID.push(e.target.value);
    } else {
      index = marketID.indexOf(e.target.value);
      marketID.splice(index, 1);
    }
    this.setState({ marketID: marketID });
  }

  handleAllCities = (e) => {
    if (e.target.checked) {
      let marketID = [];
      if(this.state.cityList){
        this.state.cityList.map((city, index) => 
          city.cities.map((cities, key) => 
            marketID.push(cities.cityID)
          )
        )
      }
      this.setState({all_city : 1, all_cities: 1, marketID: marketID });
    } else {
      this.setState({all_city : 0, all_cities: 0, marketID: [] });
    }
  }

  handleAddLocation = (e) => {
    const locationID = this.state.locationID;
    let index;

    if (e.target.checked) {
      locationID.push(e.target.value);
    } else {
      index = locationID.indexOf(e.target.attributes.getNamedItem("data-tag").value);
      locationID.splice(index, 1);

      if(this.state.quantity){
        let quantity = this.state.quantity;
        let id = e.target.attributes.getNamedItem('data-id').value;

        quantity[id] = '';
        this.setState({ quantity: quantity });
      }
    }
    this.setState({ locationID: locationID });
  }

  handleRequireLocation = (e) => {
    this.setState({requireLocation:e.target.checked});
  }

  handleLocationQty = (e) => {

    const quantity = this.state.quantity;
    let id = e.target.attributes.getNamedItem('data-id').value;
    quantity[id] = e.target.value;
    this.setState({quantity: quantity});
  }

  handleCategory(e) {
    const catID = this.state.catID;

    let index;
    let dealCategory;

    if (e.target.checked) {
      this.setState({ categoryError: "" });
      catID.push(e.target.value);
    } else {
      dealCategory = this.state.dealCategory.splice(
        e.target.attributes.getNamedItem("data-tag").value,
        1
      );
      index = catID.indexOf(e.target.value);
      catID.splice(index, 1);
    }

    this.setState({ catID: catID });
  }

  isInfinite(e) {
   if (e.target.checked) {
      const indefiniteDate = new Date(moment().startOf('day').add(100, 'years').format("YYYY-MM-DDTHH:mm"));
      this.setState({expiryDateTime : indefiniteDate});
      this.setState({ isInfinite: 1 });
      this.props.updateChildDeals(
        'expiryDateTime',
        indefiniteDate,
        this.props.index
      )
      this.props.updateChildDeals(
        e.target.name,
        1,
        this.props.index
      );
    } else {
      this.setState({expiryDateTime : ""});
      this.setState({ isInfinite: 0 });
      this.props.updateChildDeals(
        "expiryDateTime",
        "",
        this.props.index
      );
      this.props.updateChildDeals(
        e.target.name,
        0,
        this.props.index
      );
    }
  }

  removeCurrentImage(e) {
    if(!isEmpty(imageAlt) && !isEmpty(imageAlt[e])){
      imageAlt.splice(e,1);
      this.setState({ imageAlt: imageAlt });
    }
    preview = this.state.previewImage;
    preview.splice(e,1);
    this.setState({ previewImage: preview });
  }

  uploadOption(e) {
    document.getElementById("file").click();
  }

  handleQuantity(e) {
    this.setState({ [e.target.name]: e.target.value, viewDataError: '' });
  }

  handleUpdateDates(date) {
    this.setState({
      startDate: date
    });
  }

  highlights(data) {
    this.setState({
      highlights: evt.editor.getData()
    });
  }

  writeUp(e) {
    this.setState({
      writeUp: e.editor.getData()
    });
  }

  french_writeUp(e){
    this.setState({
      french_writeUp: e.editor.getData()
    });
  }

  french_termsAndConditions(e){
    this.setState({
      french_termsAndConditions: e.editor.getData()
    });
  }

  termsAndConditions(e) {
    this.setState({
      termsAndConditions: e.editor.getData()
    });
  }

  whyWeLoveIt(e) {
    this.setState({
      whyWeLoveIt: e.editor.getData()
    });
  }

  // Handle input onchange
  handleChange(e) {    
    if (`this.state.${e.target.name}Error` !== "") {
      this.setState({ [`${e.target.name}Error`]: "" });
    }
    this.setState({ [e.target.name]: e.target.value });
  }

  validate = () => {
    let isError = false;
    const errors = {};
    xCoordinate = {}
    yCoordinate = {}
    if (!this.state.mainDealText && this.state.dealAttribute.length > 1) {
      isError = true;
      this.setState({ mainDealTextError: "red" });
      if(xCoordinate.key !== 'formmainDealText'){
        let x = window.scrollX + document.querySelector('#formmainDealText').getBoundingClientRect().left
        let y = window.scrollY + document.querySelector('#formmainDealText').getBoundingClientRect().top - 89
        xCoordinate['formmainDealText'] = x;
        yCoordinate['formmainDealText'] = y;
      }
    }

    if (this.state.catID.length === 0) {
      isError = true;
      this.setState({
        categoryError: "(Please select at least one category.)"
      });
      if(xCoordinate.key !== 'formOfferDetailCategory'){
        let x = window.scrollX + document.querySelector('#formOfferDetailCategory').getBoundingClientRect().left
        let y = window.scrollY + document.querySelector('#formOfferDetailCategory').getBoundingClientRect().top - 89
        xCoordinate['formOfferDetailCategory'] = x;
        yCoordinate['formOfferDetailCategory'] = y;
      }
    }

    if (this.state.highlightFirst.length > 75){
      isError = true;
      this.setState({ highlightFirstError: "red" });
      if(xCoordinate.key !== 'formHighLightFirst'){
        let x = window.scrollX + document.querySelector('#formHighLightFirst').getBoundingClientRect().left
        let y = window.scrollY + document.querySelector('#formHighLightFirst').getBoundingClientRect().top - 89
        xCoordinate['formHighLightFirst'] = x;
        yCoordinate['formHighLightFirst'] = y;
      }
    }

    if (this.state.highlightSecond.length > 75){
      isError = true;
      this.setState({ highlightSecondError: "red" });
      if(xCoordinate.key !== 'formHighLightSecond'){
        let x = window.scrollX + document.querySelector('#formHighLightSecond').getBoundingClientRect().left
        let y = window.scrollY + document.querySelector('#formHighLightSecond').getBoundingClientRect().top - 89
        xCoordinate['formHighLightSecond'] = x;
        yCoordinate['formHighLightSecond'] = y;
      }
    }

    if (this.state.highlightThird.length > 75){
      isError = true;
      this.setState({ highlightThirdError: "red" });
      if(xCoordinate.key !== 'formHighLightThird'){
        let x = window.scrollX + document.querySelector('#formHighLightThird').getBoundingClientRect().left
        let y = window.scrollY + document.querySelector('#formHighLightThird').getBoundingClientRect().top - 89
        xCoordinate['formHighLightThird'] = x;
        yCoordinate['formHighLightThird'] = y;
      }
    }

    if (this.state.highlightFourth.length > 75){
      isError = true;
      this.setState({ highlightFourthError: "red" });
      if(xCoordinate.key !== 'formHighLightFourth'){
        let x = window.scrollX + document.querySelector('#formHighLightFourth').getBoundingClientRect().left
        let y = window.scrollY + document.querySelector('#formHighLightFourth').getBoundingClientRect().top - 89
        xCoordinate['formHighLightFourth'] = x;
        yCoordinate['formHighLightFourth'] = y;
      }
    }

    if (this.state.marketID.length == 0){
      isError = true;
      this.setState({marketError: " In order to schedule a offer you must select at least one market to run it in."});
      if(xCoordinate.key !== 'multi-location'){
        let x = window.scrollX + document.querySelector('#multi-location').getBoundingClientRect().left
        let y = window.scrollY + document.querySelector('#multi-location').getBoundingClientRect().top - 89
        xCoordinate['multi-location'] = x;
        yCoordinate['multi-location'] = y;
      }
    }
    
    if (this.state.dealAttributeError) {
      isError = true;
      let controlField
      this.state.dealAttributeErrors.forEach(function (dealAttribute, index) {
        controlField = dealAttribute.field + "ControlId-" + dealAttribute.index
        if(document.getElementById(controlField))
          document.getElementById(controlField).nextElementSibling.style.borderColor = "red"
      });
      
      
      if(xCoordinate.key !== controlField) {
        let x = window.scrollX + document.querySelector('#'+controlField).getBoundingClientRect().left
        let y = window.scrollY + document.querySelector('#'+controlField).getBoundingClientRect().top - 89
        xCoordinate[controlField] = x;
        yCoordinate[controlField] = y;
      }

    }

    return isError;
  };

  handleSubmit(e) {
    e.preventDefault();
    let actionType = e.target.attributes.getNamedItem('data-key').value;
    const err = this.validate();
    const startDateTimeConst = this.state.startDateTime
      ?  moment(this.state.startDateTime).format("YYYY-MM-DD HH:mm:ss")
      : "";
    const expiryDateTimeConst = this.state.expiryDateTime
      ?  moment(this.state.expiryDateTime).format("YYYY-MM-DD HH:mm:ss")
      : "";
    const startPauseDateTimeConst = this.state.startPauseDateTime
      ?  moment(this.state.startPauseDateTime).format("YYYY-MM-DD HH:mm:ss")
      : "";
    const endPauseDateTimeConst = this.state.endPauseDateTime
      ?  moment(this.state.endPauseDateTime).format("YYYY-MM-DD HH:mm:ss")
      : "";
    if (!err) {
      let dealText = (this.state.dealAttribute) ? this.state.dealAttribute[0]['dealText'] : '';
      let french_dealText = (this.state.dealAttribute) ? this.state.dealAttribute[0]['french_dealText'] : '';
      this.setState({ submitValue: "Saving..", disabled: true });
      const formData = new FormData();
      formData.append("mainDealText", (this.state.dealAttribute.length > 1) ? this.state.mainDealText : dealText);
      formData.append("dealID", this.state.dealID);
      formData.append("detail", JSON.stringify(this.state.dealAttribute));
      formData.append("highlights", JSON.stringify({
        first: this.state.highlightFirst,
        second: this.state.highlightSecond,
        third: this.state.highlightThird,
        fourth: this.state.highlightFourth,
      }));
      formData.append("writeUp", (this.state.writeUp) ? this.state.writeUp : "");
      formData.append("termsAndConditions", (this.state.termsAndConditions) ? this.state.termsAndConditions : "");
      formData.append("whyWeLoveIt", this.state.whyWeLoveIt);
      formData.append("startDateTime", startDateTimeConst);
      formData.append("expiryDateTime", expiryDateTimeConst);
      formData.append("isInfinite", this.state.isInfinite);
      formData.append("dealText", this.state.dealText);
      formData.append("french_dealText", this.state.french_dealText);
      formData.append("fontSize", this.state.fontSize);
      formData.append("shortTitle", (this.state.shortTitle) ? this.state.shortTitle : '');
      formData.append("useProdName", (this.state.useProdName) ? this.state.useProdName : "");
      formData.append("prodName", (this.state.prodName) ? this.state.prodName : "");
      formData.append(
        "useMerchantDefaultTax",
        this.state.useMerchantDefaultTax
      );
      formData.append("willCall", this.state.willCall);
      formData.append("showPurchasedCount", this.state.showPurchasedCount);
      formData.append("showQuantityLeft", this.state.showQuantityLeft);
      formData.append("allowCouponCodes", this.state.allowCouponCodes);
      formData.append("marketingPixelUrl", (this.state.marketingPixelUrl) ? this.state.marketingPixelUrl : "");
      //formData.append("freeShipping", this.state.freeShipping);
      //formData.append("shippingAmount", this.state.shippingAmount);
      //formData.append( "shippingAmountMerchant", this.state.shippingAmountMerchant);
      //formData.append("shippingAmountAdmin", this.state.shippingAmountAdmin);
      formData.append("isTaxable", this.state.isTaxable);
      formData.append("storeCredit", this.state.storeCredit);
      formData.append("redeemedAtCall", this.state.redeemedAtCall);
      formData.append("checkoutNotes", (this.state.checkoutNotes) ? this.state.checkoutNotes : "");
      formData.append("productPageUrl", (this.state.productPageUrl) ? this.state.productPageUrl : "");
      formData.append("allowPaypal", this.state.allowPaypal);
      formData.append("isPrivate", this.state.isPrivate);
      formData.append("productHideLocation", this.state.productHideLocation);
      formData.append("paused", this.state.paused);
      formData.append("usePauseTimer", this.state.usePauseTimer);
      formData.append("endPauseDateTime", endPauseDateTimeConst);
      formData.append("startPauseDateTime", startPauseDateTimeConst);
      formData.append("displayTimer", this.state.displayTimer);
      formData.append("timerStartInHour", this.state.timerStartInHour);
      formData.append("shipable", this.state.shipable);
      formData.append("catID", this.state.catID);
      formData.append("offer_url", (this.state.offer_url) ? this.state.offer_url : this.state.default_url);
      formData.append("offer_meta_title", (this.state.offer_meta_title) ? this.state.offer_meta_title : "");
      formData.append("french_offer_meta_title", (this.state.french_offer_meta_title) ? this.state.french_offer_meta_title : "");
      formData.append("offer_description", (this.state.offer_description) ? this.state.offer_description : "");
      formData.append("french_offer_description", (this.state.french_offer_description) ? this.state.french_offer_description : "");
      formData.append("imageAlt", JSON.stringify(this.state.imageAlt));
      formData.append("offer_status", actionType);
      formData.append("marketID", this.state.marketID);
      formData.append("all_city", this.state.all_city);
      formData.append("french_highlights", JSON.stringify({
        first: this.state.frenchhighlightFirst,
        second: this.state.frenchhighlightSecond,
        third: this.state.frenchhighlightThird,
        fourth: this.state.frenchhighlightFourth,
      }));
      formData.append("french_checkoutNotes", this.state.french_checkoutNotes);
      formData.append("french_prodName", this.state.french_prodName);
      formData.append("french_shortTitle", this.state.french_shortTitle);
      formData.append("french_termsAndConditions", this.state.french_termsAndConditions);
      formData.append("french_writeUp", this.state.french_writeUp);
      formData.append("french_mainDealText", this.state.french_mainDealText);
      formData.append("requireLocation", (this.state.requireLocation===true ? 1 : 0));
      this.props.editProductList(formData);

      if (this.state.locationID.length > 0) {
        let locationID = [];
        let merchantLocation = [];
        let quantity = this.state.quantity;
        let qun;
        this.state.locationID.map((data, key) => {
            qun = (quantity[data]) ? quantity[data] : '';
            merchantLocation.push({data, qun});
          }
        );
        const locData = {
          locID: merchantLocation,
          active: '1',
          dealID: this.state.dealID,
        };
        this.props.addDealLocation(locData, this.state.dealID);
      }else{
         const locData = {
            locID: [],
            active: '0',
            dealID: this.state.dealID,
          };
          this.props.addDealLocation(locData, this.state.dealID);
      }

    }
    else{
      let arr = Object.values(yCoordinate)
      let min = Math.min(...arr);
      let yCoordinateKey= '',yCoordinateValue, xCoordinateValue
      {Object.keys(yCoordinate).map((key) => {
        if(yCoordinate[key] === min && yCoordinateKey.length == 0){
          yCoordinateValue = yCoordinate[key]
          yCoordinateKey = key
        }
      })}
      if(yCoordinateKey.length > 0){
        xCoordinateValue = xCoordinate[yCoordinateKey]
        window.scrollTo(xCoordinateValue,yCoordinateValue)
      }
    }
  }

  handlePageChange = page => {
    let dealID = this.props.match.params.dealID
      ? this.props.match.params.dealID
      : "";
    if (dealID !== "") {
      isLoading = "true";
      this.props.getDealDetail(dealID);
    }

    const postData = {
      page: 0,
      categoryType: 'products',
    };

    this.props.getAllCategory(postData);
    this.props.getSiteCity();
  };

  componentDidMount() {
    this.handlePageChange();
  }

  componentWillMount() {
    let siteData = JSON.parse(localStorage.getItem('siteDDBStatus'));

    if(siteData){
      if(siteData.multi_lang){
        this.setState({
          multi_lang: siteData.multi_lang
        });
      }
    }
    this.props.clearAlert();
    this.handleDismiss();
  }

  componentWillReceiveProps(nextProps) {
    
    if(!aclUtil.isPrimaryMenuAccessible(this.state.menuKey)){
      this.context.router.history.push("/restrictedAccess");
    }

    if(this.props.cityList != nextProps.cityList){
      if(nextProps.cityList){
        this.setState({cityList: nextProps.cityList.data});
      }
    }

    if (
      this.props.dealDetail !== nextProps.dealDetail &&
      !isEmpty(nextProps.dealDetail)
    ) {
      if (nextProps.dealDetail) {
        preview = [];
        this.setState({ previewImage: "", selectedFile: [] });
        let deal = nextProps.dealDetail;
        this.props.get_merchant_location_details(deal.merchantID);
        const result1 = deal.endPauseDateTime && deal.endPauseDateTime.substring(0,10)
        const result2 = deal.startPauseDateTime && deal.startPauseDateTime.substring(0,10)
        const endPauseDateTimeConst = (deal.endPauseDateTime != null &&  result1 != '1970-01-01' && deal.endPauseDateTime != '')
          ? new Date(moment(deal.endPauseDateTime).format("YYYY-MM-DDTHH:mm"))
          : "";

    const startPauseDateTimeConst = (deal.startPauseDateTime != null && result2 != '1970-01-01' && deal.endPauseDateTime != '')
      ? new Date(moment(deal.startPauseDateTime).format("YYYY-MM-DDTHH:mm"))
      : "";
        const startDateTime = deal.startDateTime
          ? new Date(moment(deal.startDateTime).format("YYYY-MM-DDTHH:mm"))
          : "";
        const checkoutNotesConst =
          deal.checkoutNotes === "null" ? "" : deal.checkoutNotes;
        const marketingPixelUrlConst =
          deal.marketingPixelUrl === "null" ? "" : deal.marketingPixelUrl;
        const prodNameConst = deal.prodName === "null" ? "" : deal.prodName;  
        const productPageUrlConst =
          deal.productPageUrl === "null" ? "" : deal.productPageUrl;
        let highlights = (deal.highlights) ? JSON.parse(deal.highlights) : '';
        let french_highlights = (deal.french_highlights) ? JSON.parse(deal.french_highlights) : '';
        let freeShipping;
        this.setState({
          dealDetail: nextProps.dealDetail,
          dealID: this.state.dealID ? this.state.dealID : deal.dealID,
          merchantID: this.state.merchantID ? this.state.merchantID : deal.merchantID,
          highlightFirst: (highlights) ? highlights.first : '',
          highlightSecond: (highlights) ? highlights.second : '',
          highlightThird: (highlights) ? highlights.third : '',
          highlightFourth: (highlights) ? highlights.fourth : '',
          writeUp: this.state.writeUp ? this.state.writeUp : deal.writeUp,
          termsAndConditions: this.state.termsAndConditions ? this.state.termsAndConditions : deal.termsAndConditions,
          mainDealText: this.state.mainDealText ? this.state.mainDealText : (deal.mainDealText ? deal.mainDealText : (this.state.dealText ? this.state.dealText : deal.dealText)),
          whyWeLoveIt: this.state.whyWeLoveIt ? this.state.whyWeLoveIt : deal.whyWeLoveIt,
          startDateTime: startDateTime,
          expiryDateTime: new Date(deal.expiryDateTime),
          isInfinite: this.state.isInfinite ? this.state.isInfinite : deal.isInfinite,
          dealText: this.state.dealText ? this.state.dealText : deal.dealText,
          french_dealText: this.state.french_dealText ? this.state.french_dealText : deal.french_dealText,
          fontSize: this.state.fontSize ? this.state.fontSize : deal.fontSize,
          shortTitle: this.state.shortTitle ? this.state.shortTitle : deal.shortTitle,
          useProdName: this.state.useProdName ? this.state.useProdName : deal.useProdName,
          prodName: this.state.prodNameConst ? this.state.prodNameConst : prodNameConst,
          useMerchantDefaultTax: deal.useMerchantDefaultTax,
          willCall: deal.willCall,
          showPurchasedCount: deal.showPurchasedCount,
          showQuantityLeft: deal.showQuantityLeft,
          allowCouponCodes: deal.allowCouponCodes,
          marketingPixelUrl: deal.marketingPixelUrl,
          // freeShipping: this.state.freeShipping ? this.state.freeShipping : deal.freeShipping, //(deal.shipable == "1") ? "1" : "0"
          // shippingAmount: this.state.shippingAmount ? this.state.shippingAmount : deal.shippingAmount,
          // shippingAmountMerchant: this.state.shippingAmountMerchant ? this.state.shippingAmountMerchant : deal.shippingAmountMerchant,
          // shippingAmountAdmin: this.state.shippingAmountAdmin ? this.state.shippingAmountAdmin : deal.shippingAmountAdmin,
          isTaxable: deal.isTaxable,
          storeCredit: deal.storeCredit,
          redeemedAtCall: deal.redeemedAtCall,
          checkoutNotes:  deal.checkoutNotes,
          productPageUrl: deal.productPageUrl,
          allowPaypal: deal.allowPaypal,
          isPrivate:  deal.isPrivate,
          productHideLocation:  deal.productHideLocation,
          paused: deal.paused,
          usePauseTimer: deal.usePauseTimer,
          endPauseDateTime: (endPauseDateTimeConst) ? endPauseDateTimeConst : '',
          startPauseDateTime: (startPauseDateTimeConst) ? startPauseDateTimeConst : '',
          displayTimer:  deal.displayTimer,
          timerStartInHour:  deal.timerStartInHour,
          //shipable: deal.freeShipping ? deal.freeShipping : this.state.shipable,
          dealImages: deal.dealImages,
          dealAttribute: this.state.dealAttribute ? this.state.dealAttribute : deal.child_deals,
          offer_url: (deal.offer_url) ? deal.offer_url : deal.child_deals[0].dealID+'-'+deal.legalName.toLowerCase().trim().split(/\s+/).join('-'),
          offer_meta_title: this.state.offer_meta_title ? this.state.offer_meta_title : deal.offer_meta_title,
          french_offer_meta_title: this.state.french_offer_meta_title ? this.state.french_offer_meta_title : deal.french_offer_meta_title,
          offer_description: this.state.offer_description ? this.state.offer_description : deal.offer_description,
          french_offer_description: this.state.french_offer_description ? this.state.french_offer_description : deal.french_offer_description,
          default_url: deal.child_deals[0].dealID+'-'+deal.legalName.toLowerCase().trim().split(/\s+/).join('-'),
          all_city: deal.all_city,
          frenchhighlightFirst: (french_highlights) ? french_highlights.first : '',
          frenchhighlightSecond: (french_highlights) ? french_highlights.second : '',
          frenchhighlightThird: (french_highlights) ? french_highlights.third : '',
          frenchhighlightFourth: (french_highlights) ? french_highlights.fourth : '',
          french_checkoutNotes: deal.french_checkoutNotes,
          french_prodName: deal.french_prodName,
          french_shortTitle: deal.french_shortTitle,
          french_mainDealText: deal.french_mainDealText,
          french_termsAndConditions: deal.french_termsAndConditions,
          french_writeUp: deal.french_writeUp,
          requireLocation:(deal.requireLocation=='1' ? true : false)
        });

        if (nextProps.dealDetail.dealCategory) {
          this.setState({ dealCategory: nextProps.dealDetail.dealCategory });

          let catID = [];
          nextProps.dealDetail.dealCategory.map((category, index) =>
            catID.push(category.catID)
          );

          this.setState({ catID: catID });
        }

        if (!isEmpty(nextProps.dealDetail.dealLocation)) {
          let locationID = [], quantity = [];
          nextProps.dealDetail.dealLocation.map((data, index) => {
            locationID.push(data.locID);
            quantity[data.locID] = data.quantity;
          });
          this.setState({locationID: locationID, quantity: quantity});
        }

        if(nextProps.dealDetail.dealmarket.length > 0){
          let marketID = [];
          nextProps.dealDetail.dealmarket.map((market, key) =>
            marketID.push(market.cityID)
          )
             
          this.setState({marketID: marketID, defaultCity: JSON.parse(localStorage.getItem('defaultCity'))});
        }else{
            let marketID = [];
            marketID.push(JSON.parse(localStorage.getItem('defaultCity')));
            this.setState({marketID: marketID, defaultCity: JSON.parse(localStorage.getItem('defaultCity'))});
        }
        isLoading = "false";
      }
    }

    if (
      this.props.catList !== nextProps.catList &&
      !isEmpty(nextProps.catList)
    ) {
      if (nextProps.catList) {
        this.setState({ catList: nextProps.catList.data });
      }
    }

    if (
      this.props.merchantLocationDetails !==
        nextProps.merchantLocationDetails &&
      !isEmpty(nextProps.merchantLocationDetails)
    ) {
      this.setState({ merchantLocation: nextProps.merchantLocationDetails });
    }

    if (this.props.editDeal !== nextProps.editDeal) {
      if (nextProps.editDeal) {
        this.props.clearAlert();
        this.handleShow();
        this.props.renderAlert("success", nextProps.editDeal.message);
        this.setState({ submitValue: "Save", disabled: false, viewData: '', location : '', locationQuantity : '' });
        this.props.getDealDetail(this.state.dealID);
      }
      window.scrollTo(0, 0);
    }

    
    if(this.props.attributeStatus !== nextProps.attributeStatus){
      if(nextProps.attributeStatus){
        isLoading = "false";
        this.props.getDealDetail(this.state.dealID);
        this.closeAttribute();
      }
    }

    if (this.props.error !== nextProps.error) {
      if (nextProps.error) {
        this.setState({ submitValue: "Save", disabled: false });
        this.props.clearAlert();
        this.handleShow();
        this.props.renderAlert("warning", nextProps.error);
      }
      window.scrollTo(0, 0);
    }

    if(this.props.imageStatus !== nextProps.imageStatus){
      if(nextProps.imageStatus){
        if(nextProps.imageStatus.data.response == "success"){
          this.handlePageChange();
          this.closeCropPopup();
        }
      }
    }

    if (nextProps.message) {
      this.handleShow();
      this.setState({
        alertMessage: nextProps.message,
        msgType: nextProps.alertType
      });
    }
  }
  shouldComponentUpdate(nextProps, nextState) {
    if (this.state.dealDetail !== nextState.dealDetail) {
      return false
    }
    return true
  }

  handleProductName(event) {
    this.setState({ [event.target.name]: event.target.value });
    let useProdName = event.target.value;
    this.setState({ useProdName: event.target.value });
    if (useProdName === "1") {
      this.setState({ show: true });
    } else {
      this.setState({ show: false });
    }
  }

  updateChildDeals = (field, value, idx, otherFields = []) => {
    const newAttribute = this.state.dealAttribute.map((data, pidx) => {
      if (idx !== pidx) {
        return data
      } else {
        if (field === 'freeShipping') {
          if (value === '1') {
            this.setShippingAttrRequired(idx, false)
            return {
              ...data,
              [field]: value,
              shippingAmountAdmin: 0,
              shippingAmountMerchant: 0,
              shippingAmount: 0,
              shipable: 1,
            }
          } else {
            this.setShippingAttrRequired(idx, true)
            return { ...data, [field]: value, shipable: 1 }
          }
        } else if (
          field === 'shippingAmount' ||
          field === 'shippingAmountMerchant' ||
          field === 'shippingAmountAdmin'
        ) {
          this.resetShippingAttrRequired(idx, true, field)
          return { ...data, [field]: value }
        } else {
          return { ...data, [field]: value }
        }
      }
    })
    if(otherFields.length > 0) {
      otherFields.map((o,i) => {
        newAttribute[idx][o.field] = o.value;
      })
      
    }
    this.setState({ dealAttribute: newAttribute })
  }

  setShippingAttrRequired = async (index, reset) => {
    await this.setDealAttributeError('shippingAmount', index, reset)
    await this.setDealAttributeError('shippingAmountMerchant', index, reset)
    await this.setDealAttributeError('shippingAmountAdmin', index, reset)
  }
  resetShippingAttrRequired = async (index, reset, field) => {
    await this.setDealAttributeError(field, index, reset)
  }

  setDealAttributeError = async (field, index, reset) => {
    let dealAttributeErrors
    const controlField = field + "ControlId-" + index;
    if (reset) {
      if(field === 'shippingAmountMerchant') {
        const adminControlField = "shippingAmountAdminControlId-" + index;
        if(parseInt(document.getElementById(controlField).nextElementSibling.value) +  
          parseInt(document.getElementById(adminControlField).nextElementSibling.value) === 100) {
          await this.unsetAttributeFromErrors(adminControlField, "shippingAmountAdmin")
        } else {
          dealAttributeErrors = this.state.dealAttributeErrors.concat([{ field:"shippingAmountAdmin", index }])
          await this.updateErrorsInState(dealAttributeErrors)
        }
      } else if(field === 'shippingAmountAdmin') {
        const merchantControlField = "shippingAmountMerchantControlId-" + index;
        if(parseInt(document.getElementById(controlField).nextElementSibling.value) +  
          parseInt(document.getElementById(merchantControlField).nextElementSibling.value) === 100) {
          await this.unsetAttributeFromErrors(merchantControlField, "shippingAmountMerchant")
        } else {
          dealAttributeErrors = this.state.dealAttributeErrors.concat([{ field:"shippingAmountMerchant", index }])
          await this.updateErrorsInState(dealAttributeErrors)
        }
      }
      await this.unsetAttributeFromErrors(controlField, field)
    } else {
      dealAttributeErrors = this.state.dealAttributeErrors.concat([{ field, index }])
      await this.updateErrorsInState(dealAttributeErrors)
    }
  }

  unsetAttributeFromErrors = async(controlField, field) => {
    if(document.getElementById(controlField)) {
      document.getElementById(controlField).nextElementSibling.style.borderColor = ""
    }
    const dealAttributeErrors = this.state.dealAttributeErrors.filter(
      element => element.field !== field
    )  
    await this.updateErrorsInState(dealAttributeErrors)
  }
  
  updateErrorsInState = async (dealAttributeErrors) => {
    await this.setState({
      dealAttributeError: dealAttributeErrors.length ? true : false,
      dealAttributeErrors: dealAttributeErrors,
    })
  }

  render() {
    const { crop, croppedImageUrl, src } = this.state;
    let listCategory = [];
    if (this.state.dealCategory) {
      this.state.dealCategory.map((category, index) =>
        listCategory.push(category.catID)
      );
    }

    let marketRun;
    if(this.state.cityList){
      marketRun = this.state.cityList.map((city, index) => 
        <Row key={index}>
          <Col md={12} xs={12}>
            <b>{city.country}</b>
          </Col>
          {city.cities &&
            <Col md={12} xs={12}>
              <Row>
              {city.cities.map((cities, key) => 
                <Col md={3} xs={6}>
                  {this.state.marketID.indexOf(cities.cityID) > -1 ? (
                    <Checkbox
                      name="marketRun[]"
                      key={cities.cityID}
                      value={cities.cityID}
                      data-tag={key}
                      checked
                      onChange={this.handleMarketRun}
                    >
                      {(this.state.defaultCity == cities.cityID) ?
                      <b>{cities.title}</b>  
                      :
                      cities.title
                      }
                    </Checkbox>
                  ) : (
                    <Checkbox
                      name="marketRun[]"
                      key={cities.cityID}
                      value={cities.cityID}
                      data-tag={key}
                      checked={(this.state.all_cities == 1) ? true : false}
                      onChange={this.handleMarketRun}
                    >
                      {(this.state.defaultCity == cities.cityID) ?
                      <b>{cities.title}</b>  
                      :
                      cities.title
                      }
                    </Checkbox>
                  )}
                </Col>
              )}
              </Row>
            </Col>
          }
        </Row>
      )
    }

    let mechantCol;
    let quantity = (this.state.quantity) ? this.state.quantity : '';
    if (this.state.merchantLocation) {
      mechantCol = this.state.merchantLocation.data.map((merchant, index) => (
        <Row key={merchant.locID}>
          <Col md={6} xs={12}>
            {this.state.locationID.indexOf(merchant.locID) > -1 ? (
              <Checkbox
                name="merchantLocation[]"
                key={merchant.locID}
                value={merchant.locID}
                data-tag={merchant.locID}
                checked
                onChange={this.handleAddLocation}
                data-id={merchant.locID}
              >
               {merchant.locAddress1}, {(merchant.locAddress2) ? merchant.locAddress2+',' : ''} {merchant.locCity}, {merchant.locState}, {merchant.locCountry}
              </Checkbox>
            ):(
              <Checkbox
                name="merchantLocation[]"
                key={merchant.locID}
                value={merchant.locID}
                data-tag={merchant.locID}
                onChange={this.handleAddLocation}
                data-id={merchant.locID}
              >
               {merchant.locAddress1}, {(merchant.locAddress2) ? merchant.locAddress2 + ',' : ''} {merchant.locCity}, {merchant.locState}, {merchant.locCountry}
              </Checkbox>
            )}
          </Col>
          <Col md={6} xs={12}>
          <FormControl name="merchantLocationQuantity[]" value={(quantity && quantity[merchant.locID]) ? quantity[merchant.locID] : ''} data-id={merchant.locID} type="number" placeholder="Enter Qty." onChange={this.handleLocationQty} />
          </Col>
        </Row>
      ));
    }

    let catCol;
    if (this.state.catList.length > 0) {
      catCol = this.state.catList.map((catObject, index) => {
        let checked = listCategory.indexOf(catObject.catID) > -1 ? "true" : "";
        let indexValue = listCategory.indexOf(catObject.catID);
        return (
          <Col md={2} xs={4} key={catObject.catID}>
            <FormGroup controlId={catObject.catName}>
              {listCategory.indexOf(catObject.catID) > -1 ? (
                <Checkbox
                  name="category[]"
                  inline
                  key={Math.random()}
                  checked
                  value={catObject.catID}
                  data-tag={indexValue}
                  onChange={this.handleCategory}
                >
                  {catObject.catName}
                </Checkbox>
              ) : (
                <Checkbox
                  name="category[]"
                  inline
                  key={index}
                  value={catObject.catID}
                  data-tag={indexValue}
                  onChange={this.handleCategory}
                >
                  {catObject.catName}
                </Checkbox>
              )}
            </FormGroup>
          </Col>
        );
      });
    }

    return (
      <div className="col-lg-12 add-sub-admin">
        {isLoading == "true" ? (
          <div className="loader">
            <p className="loading-message">
              <i>Loading...</i>
            </p>
            <div className="spinner">
              <div className="dot1" />
              <div className="dot2" />
            </div>
          </div>
        ) : (
          ""
        )}
        <form encType="multipart/form-data">
          <div className="row">
            <div className="col-xs-12">
              <BreadcrumbComponent path={this.state.path} links={this.state.links} context={this.context}/>
            </div>
          </div>
          {/**start product information **/}
          <div className="panel">
            <header className="panel-heading">Offer Product Details</header>

            {this.state.show &&
              this.state.alertMessage !== "" && (
                <div className="col-lg-12">
                  <Alert
                    bsStyle={this.state.msgType}
                    onDismiss={this.handleDismiss}
                  >
                    <strong>{this.state.msgType}:</strong>{" "}
                    {this.state.alertMessage}
                  </Alert>
                </div>
              )}

            <div className="panel-body">
              {!isEmpty(this.state.dealAttribute) &&
                this.state.dealAttribute.map((data, index) => (
                  <React.Fragment>
                    <DealAttribute
                      deal={data}
                      index={index}
                      key={index}
                      updateChildDeals={this.updateChildDeals}
                      timezone={(this.state.dealDetail && this.state.dealDetail.timezone ? this.state.dealDetail.timezone : 'America/New_York')}
                      setDealAttributeError={this.setDealAttributeError}
                    />
                    {(index === 0) &&
                    <Col md={12} xs={12}>
                    <Row>
                      <Col md={12} xs={12}>
                        <FormGroup controlId="formshortTitle">
                          <ControlLabel>
                            Short Title (Text
                            that appears on More Offers and on Affiliate Ad Units)
                          </ControlLabel>
                          <FormControl
                            type="text"
                            value={(this.state.shortTitle) ? this.state.shortTitle : ""}
                            placeholder="Short Title"
                            onChange={this.handleChange}
                            name="shortTitle"
                            style={{ borderColor: this.state.shortTitleError }}
                          />
                        </FormGroup>
                      </Col>
                    </Row>
                    {(this.state.multi_lang == "yes") &&
                    <Row>
                      <Col md={12} xs={12}>
                        <FormGroup controlId="formfrenchshortTitle">
                          <ControlLabel>
                            Short Title (Text
                            that appears on More Offers and on Affiliate Ad Units in Canadian French)
                          </ControlLabel>
                          <FormControl
                            type="text"
                            value={(this.state.french_shortTitle) ? this.state.french_shortTitle : ""}
                            placeholder="Short Title"
                            onChange={this.handleChange}
                            name="french_shortTitle"
                          />
                        </FormGroup>
                      </Col>
                    </Row>
                    }
                    <Row>
                      <Col md={12} xs={12}>
                        <ControlLabel>
                          Would you like to use a Product Name in place of the
                          Merchant Name?
                        </ControlLabel>
                      </Col>
                    </Row>
                    <Row>
                      <Col md={4} xs={12}>
                        <FormGroup controlId="formUseProdName">
                          <FormControl
                            value={(this.state.useProdName) ? this.state.useProdName : ''}
                            onChange={this.handleProductName.bind(this)}
                            componentClass="select"
                            name="useProdName"
                            placeholder="select"
                          >
                            <option value="0">No</option>
                            <option value="1">Yes</option>
                          </FormControl>
                        </FormGroup>
                      </Col>
                      {(this.state.show == true || this.state.useProdName == 1) ? (
                        <Col md={4} xs={12}>
                          <FormGroup controlId="formprodName">
                            <FormControl
                              type="text"
                              value={(this.state.prodName) ? this.state.prodName : ""}
                              placeholder="Product Name"
                              onChange={this.handleChange}
                              name="prodName"
                            />
                          </FormGroup>
                        </Col>
                      ) : null}
                      {((this.state.show == true  || this.state.useProdName == 1) && (this.state.multi_lang == "yes"))? (
                        <Col md={4} xs={12}>
                          <FormGroup controlId="formfrenchprodName">
                            <FormControl
                              type="text"
                              value={(this.state.french_prodName) ? this.state.french_prodName : ""}
                              placeholder="Product Name  (Canadian French)"
                              onChange={this.handleChange}
                              name="french_prodName"
                            />
                          </FormGroup>
                        </Col>
                      ) : null}
                    </Row>

                    </Col>
                    }
                    <Col md={12} xs={12}>
                      <hr />
                    </Col>
                  </React.Fragment>
                ))}
            </div>
          </div>
          {/**end product information **/}

          {/**start Images container **/}
          <div className="panel">
            <FormControl
              type="file"
              id="file"
              style={{ display: "none" }}
              // multiple
              onChange={this.handleFormData}
            />
            <header className="panel-heading">
              Images{" "}
              <span className="text-danger" style={{ fontSize: '12px', textTransform: 'none' }}>(Minimum Image Size: 924px X 520px)</span>
              <Button
                bsStyle="success"
                bsSize="xsmall"
                className="pull-right"
                onClick={this.uploadOption.bind(this)}
              >
                Upload Images
              </Button>
            </header>
            <div className="panel-body">
              <div className="add-city col-lg-12 col-md-12 col-sm-12 col-xs-12">
                <Row>
                  <Col md={12} xs={6}>
                    { this.state.dealImages &&
                      <div>
                        <DragDropContext onDragEnd={this.onDragEnd}>
                          <Droppable droppableId="droppable" direction="horizontal">
                            {(provided, snapshot) => (
                              <div
                                ref={provided.innerRef}
                                style={getListStyle(snapshot.isDraggingOver)}
                                {...provided.droppableProps}
                              >
                                { 
                                  this.state.dealImages.map((item, index) => (
                                    <Draggable key={item.id} draggableId={item.id} index={index}>
                                      {(provided, snapshot) => (
                                        <div
                                          ref={provided.innerRef}
                                          {...provided.draggableProps}
                                          {...provided.dragHandleProps}
                                          style={getItemStyle(
                                            snapshot.isDragging,
                                            provided.draggableProps.style,
                                            index
                                          )}
                                        >
                                            <Image
                                              key={index}
                                              src={item.dealID}
                                              width="150px"
                                              thumbnail
                                            />
                                            <Badge
                                              bsStyle="danger"
                                              style={{
                                                top: "-4%",
                                                position: "absolute",
                                                right: "-2%"
                                              }}
                                              onClick={this.removeImage.bind(
                                                this,
                                                item.id,
                                                index
                                              )}
                                            >
                                              <i className="glyphicon glyphicon-remove" />
                                            </Badge>
                                            <div className="text-center">
                                              <a 
                                                onClick={this.openAttribute} 
                                                data-text={(item.img_text) ? item.img_text : 'null'} 
                                                data-desc={(item.img_desc) ? item.img_desc : 'null'} 
                                                data-alt={(item.img_alt_text) ? item.img_alt_text : 'null'} 
                                                data-id={item.id} 
                                                data-img={item.dealID}
                                                data-imagestatus="old"
                                              >
                                                Edit image attributes
                                              </a>
                                            </div>
                                        </div>
                                      )}
                                    </Draggable>
                                ))}
                                {provided.placeholder}
                              </div>
                            )}
                          </Droppable>
                        </DragDropContext>
                        <span className="text-info" style={{ fontSize: '12px', textTransform: 'none' }}>(Highlighted Image is the main deal image)</span>
                      </div>
                    }
                  </Col>
                </Row>
              </div>
            </div>
          </div>
          {/**end Images container  **/}

          {/**start contract information **/}
          <div className="panel">
            <header className="panel-heading">Product Scheduling Option</header>
            <div className="panel-body">
              <div className="add-city col-lg-12 col-md-12 col-sm-12 col-xs-12">
                {(this.state.dealAttribute.length > 1) &&
                <Row>
                  <Col md={12} xs={12}>
                    <ControlLabel>
                      <span style={{ color: "red" }}>*</span> Main Product
                      Text{" "}
                    </ControlLabel>
                  </Col>
                </Row>
                }
                {(this.state.dealAttribute.length > 1) &&
                <Row>
                  <Col md={12} xs={12}>
                    <FormGroup controlId="formmainDealText">
                      <FormControl
                        type="text"
                        value={(this.state.mainDealText) ? ReactHtmlParser(this.state.mainDealText) : ReactHtmlParser(this.state.dealText)}
                        placeholder="Deal Text"
                        onChange={this.handleChange}
                        name="mainDealText"
                        style={{ borderColor: this.state.mainDealTextError }}
                      />
                    </FormGroup>
                  </Col>
                </Row>
                } 
                {(this.state.dealAttribute.length > 1 && this.state.multi_lang == "yes") &&
                <Row>
                  <Col md={12} xs={12}>
                    <ControlLabel>
                      <span style={{ color: "red" }}>*</span> Main Product
                      Text (Canadian French){" "}
                    </ControlLabel>
                  </Col>
                </Row>
                }
                {(this.state.dealAttribute.length > 1 && this.state.multi_lang == "yes") &&
                <Row>
                  <Col md={12} xs={12}>
                    <FormGroup controlId="french_mainDealText">
                      <FormControl
                        type="text"
                        value={(this.state.french_mainDealText) ? ReactHtmlParser(this.state.french_mainDealText) : ReactHtmlParser(this.state.french_dealText)}
                        placeholder="Deal Text"
                        onChange={this.handleChange}
                        name="french_mainDealText"
                        style={{ borderColor: this.state.french_mainDealTextError }}
                      />
                    </FormGroup>
                  </Col>
                </Row>
                }          
                <Row>
                  <Col md={6} xs={12}>
                    <ControlLabel id="multi-location">Markets to Run In <span className="text-danger">{this.state.marketError}</span></ControlLabel>
                    <Row>
                      <Col md={12} xs={12}>
                        <Checkbox
                          name="checkAll"
                          value="1"
                          checked={(this.state.all_city == 0) ? false : true}
                          onChange={this.handleAllCities}
                        >
                          <b>All Cities</b>
                        </Checkbox>
                      </Col>
                    </Row>
                    {marketRun}
                  </Col>
                  <Col md={6} xs={12}>
                    <ControlLabel id="multi-location">Multi-Location Availability (Leave blank for no quantity limit)</ControlLabel>
                    {mechantCol}
                    {mechantCol && 
                      <Checkbox
                        name="requireLocation"
                        key={Math.random()}
                        value={this.state.requireLocation} 
                        checked={this.state.requireLocation}
                        onChange={this.handleRequireLocation}
                      >
                       Require Customer To Select Location
                      </Checkbox>
                    }
                  </Col>
                </Row>
                <Row>
                  <Col md={12} xs={12}>
                    <hr />
                  </Col>
                </Row>
                <Row>
                  <Col md={12} xs={12}>
                    <ControlLabel id="formOfferDetailCategory">
                      <span style={{ color: "red" }}>*</span> Product Details
                      Category{" "}
                      <span className="inline-validation-error">
                        {this.state.categoryError !== ""
                          ? this.state.categoryError
                          : " "}
                      </span>
                    </ControlLabel>
                  </Col>
                </Row>
                <Row>{catCol}</Row>
                <Row>
                  <Col md={12} xs={12}>
                    <hr />
                  </Col>
                  <Col md={12} xs={12}>
                    <ControlLabel>Product Highlights</ControlLabel>
                  </Col>
                </Row>
                <Row>
                  <Col md={12} xs={12}>
                    <Row>
                      <Col md={8} xs={8}>
                        <FormControl
                          id="formHighLightFirst"
                          type="text"
                          name="highlightFirst"
                          value={(this.state.highlightFirst) ? this.state.highlightFirst : ""}
                          placeholder="Enter text"
                          onChange={this.handleChange}
                          style={{ borderColor: this.state.highlightFirstError }}
                        />
                      </Col>
                      <Col md={4} xs={4} className={(this.state.highlightFirst.length <= 0 || this.state.highlightFirst.length > 75) ? "text-danger" : "text-success"}>{this.state.highlightFirst.length} characters</Col>
                    </Row>
                    <Row>
                      <Col md={8} xs={8}>
                        <FormControl
                          id="formHighLightSecond"
                          type="text"
                          name="highlightSecond"
                          value={(this.state.highlightSecond) ? this.state.highlightSecond : ""}
                          placeholder="Enter text"
                          onChange={this.handleChange}
                          style={{ borderColor: this.state.highlightSecondError }}
                        />
                      </Col>
                      <Col md={4} xs={4} className={(this.state.highlightSecond.length <= 0 || this.state.highlightSecond.length > 75) ? "text-danger" : "text-success"}>{this.state.highlightSecond.length} characters</Col>
                    </Row>
                    <Row>
                      <Col md={8} xs={8}>
                        <FormControl
                          id="formHighLightThird"
                          type="text"
                          name="highlightThird"
                          value={(this.state.highlightThird) ? this.state.highlightThird : ""}
                          placeholder="Enter text"
                          onChange={this.handleChange}
                          style={{ borderColor: this.state.highlightThirdError }}
                        />
                      </Col>
                      <Col md={4} xs={4} className={(this.state.highlightThird.length <= 0 || this.state.highlightThird.length > 75) ? "text-danger" : "text-success"}>{this.state.highlightThird.length} characters</Col>
                    </Row>
                    <Row>
                      <Col md={8} xs={8}>
                        <FormControl
                          id="formHighLightFourth"
                          type="text"
                          name="highlightFourth"
                          value={(this.state.highlightFourth) ? this.state.highlightFourth : ""}
                          placeholder="Enter text"
                          onChange={this.handleChange}
                          style={{ borderColor: this.state.highlightFourthError }}
                        />
                      </Col>
                      <Col md={4} xs={4} className={(this.state.highlightFourth.length <= 0 || this.state.highlightFourth.length > 75) ? "text-danger" : "text-success"}>{this.state.highlightFourth.length} characters</Col>
                    </Row>
                  </Col>
                </Row>
                {(this.state.multi_lang == "yes") &&
                <Row>
                  <Col md={12} xs={12}>
                    <hr />
                  </Col>
                  <Col md={12} xs={12}>
                    <ControlLabel>Product Highlights (Canadian French)</ControlLabel>
                  </Col>
                </Row>
                }
                {(this.state.multi_lang == "yes") &&
                <Row>
                  <Col md={12} xs={12}>
                    <Row>
                      <Col md={8} xs={8}>
                        <FormControl
                          id="frenchhighlightFirst"
                          type="text"
                          name="frenchhighlightFirst"
                          value={(this.state.frenchhighlightFirst) ? this.state.frenchhighlightFirst : ""}
                          placeholder="Enter text"
                          onChange={this.handleChange}
                          style={{ borderColor: this.state.frenchhighlightFirstError }}
                        />
                      </Col>
                      <Col md={4} xs={4} className={(this.state.frenchhighlightFirst.length <= 0 || this.state.frenchhighlightFirst.length > 75) ? "text-danger" : "text-success"}>{this.state.frenchhighlightFirst.length} characters</Col>
                    </Row>
                    <Row>
                      <Col md={8} xs={8}>
                        <FormControl
                          id="frenchhighlightSecond"
                          type="text"
                          name="frenchhighlightSecond"
                          value={(this.state.frenchhighlightSecond) ? this.state.frenchhighlightSecond : ""}
                          placeholder="Enter text"
                          onChange={this.handleChange}
                          style={{ borderColor: this.state.frenchhighlightSecondError }}
                        />
                      </Col>
                      <Col md={4} xs={4} className={(this.state.frenchhighlightSecond.length <= 0 || this.state.frenchhighlightSecond.length > 75) ? "text-danger" : "text-success"}>{this.state.frenchhighlightSecond.length} characters</Col>
                    </Row>
                    <Row>
                      <Col md={8} xs={8}>
                        <FormControl
                          id="frenchhighlightThird"
                          type="text"
                          name="frenchhighlightThird"
                          value={(this.state.frenchhighlightThird) ? this.state.frenchhighlightThird : ""}
                          placeholder="Enter text"
                          onChange={this.handleChange}
                          style={{ borderColor: this.state.frenchhighlightThirdError }}
                        />
                      </Col>
                      <Col md={4} xs={4} className={(this.state.frenchhighlightThird.length <= 0 || this.state.frenchhighlightThird.length > 75) ? "text-danger" : "text-success"}>{this.state.frenchhighlightThird.length} characters</Col>
                    </Row>
                    <Row>
                      <Col md={8} xs={8}>
                        <FormControl
                          id="frenchhighlightFourth"
                          type="text"
                          name="frenchhighlightFourth"
                          value={(this.state.frenchhighlightFourth) ? this.state.frenchhighlightFourth : ""}
                          placeholder="Enter text"
                          onChange={this.handleChange}
                          style={{ borderColor: this.state.frenchhighlightFourthError }}
                        />
                      </Col>
                      <Col md={4} xs={4} className={(this.state.frenchhighlightFourth.length <= 0 || this.state.frenchhighlightFourth.length > 75) ? "text-danger" : "text-success"}>{this.state.frenchhighlightFourth.length} characters</Col>
                    </Row>
                  </Col>
                </Row>
                }
                <Row>
                  <Col md={12} xs={12}>
                    <hr />
                  </Col>
                  <Col md={12} xs={12}>
                    <ControlLabel>Product Write-up</ControlLabel>
                  </Col>
                </Row>
                <Row>
                  <Col md={12} xs={12}>
                    <CKEditor
                      name="writeUp"
                      content={(this.state.writeUp) ? this.state.writeUp : ""}
                      events={{
                        change: this.writeUp
                      }}
                    />
                  </Col>
                </Row>
                {(this.state.multi_lang == "yes") &&
                <Row>
                  <Col md={12} xs={12}>
                    <hr />
                  </Col>
                  <Col md={12} xs={12}>
                    <ControlLabel>Product Write-up (Canadian French)</ControlLabel>
                  </Col>
                </Row>
                }
                {(this.state.multi_lang == "yes") &&
                  <Row>
                    <Col md={12} xs={12}>
                      <CKEditor
                        name="french_writeUp"
                        content={(this.state.french_writeUp) ? this.state.french_writeUp : ""}
                        events={{
                          change: this.french_writeUp
                        }}
                      />
                    </Col>
                  </Row>
                }
                <Row>
                  <Col md={12} xs={12}>
                    <hr />
                  </Col>
                  <Col md={12} xs={12}>
                    <ControlLabel>Terms & Conditions</ControlLabel>
                  </Col>
                </Row>
                <Row>
                  <Col md={12} xs={12}>
                    <CKEditor
                      name="termsAndConditions"
                      content={(this.state.termsAndConditions) ? this.state.termsAndConditions : ""}
                      events={{
                        change: this.termsAndConditions
                      }}
                    />
                  </Col>
                </Row>
                {(this.state.multi_lang == "yes") &&
                <Row>
                  <Col md={12} xs={12}>
                    <hr />
                  </Col>
                  <Col md={12} xs={12}>
                    <ControlLabel>Terms & Conditions (Canadian French)</ControlLabel>
                  </Col>
                </Row>
                }
                {(this.state.multi_lang == "yes") &&
                <Row>
                  <Col md={12} xs={12}>
                    <CKEditor
                      name="french_termsAndConditions"
                      content={(this.state.french_termsAndConditions) ? this.state.french_termsAndConditions : ""}
                      events={{
                        change: this.french_termsAndConditions
                      }}
                    />
                  </Col>
                </Row>
                }
              </div>
            </div>
          </div>
          {/**end contract information **/}

          {/**start meta keywords **/}
          <div className="panel">
            <header className="panel-heading">Meta & Title Tag</header>
            <div className="panel-body">
              <div className="add-city col-lg-12 col-md-12 col-sm-12 col-xs-12">
                <Row>
                  <Col md={6} xs={12}>
                    <FormGroup controlId="formOfferURL">
                      <ControlLabel>
                        Product URL
                      </ControlLabel>
                      <Row>
                        <Col md={7} xs={12}>
                          <ControlLabel>{location.protocol+'//'+location.host+'/store-detail/'}</ControlLabel>{' '}
                        </Col>
                        <Col md={5} xs={12}>
                          <FormControl
                            type="text"
                            value={this.state.offer_url}
                            placeholder="Product URL"
                            onChange={this.handleChange}
                            name="offer_url"
                          />
                        </Col>
                      </Row>
                    </FormGroup>
                  </Col>
                  
                </Row>
                <Row>
                  <Col md={6} xs={12}>
                    <FormGroup controlId="formOfferMetaTitle">
                      <ControlLabel>
                        Product Meta Title
                      </ControlLabel>
                      <FormControl
                        type="text"
                        value={(this.state.offer_meta_title) ? this.state.offer_meta_title : ""}
                        placeholder="Product Meta Title"
                        onChange={this.handleChange}
                        name="offer_meta_title"
                      />
                    </FormGroup>
                  </Col>
                  {(this.state.multi_lang == "yes") &&
                  <Col md={6} xs={12}>
                    <FormGroup controlId="formFrenchOfferMetaTitle">
                      <ControlLabel>
                        Product Meta Title (Canadian French)
                      </ControlLabel>
                      <FormControl
                        type="text"
                        value={(this.state.french_offer_meta_title) ? this.state.french_offer_meta_title : ""}
                        placeholder="Product Meta Title (Canadian French)"
                        onChange={this.handleChange}
                        name="french_offer_meta_title"
                      />
                    </FormGroup>
                  </Col>
                  }
                </Row>
                <Row>
                  <Col md={6} xs={12}>
                    <FormGroup controlId="formOfferMetaDescription:">
                      <ControlLabel>
                        Product Meta Description
                      </ControlLabel>
                      <FormControl
                        type="text"
                        value={(this.state.offer_description) ? this.state.offer_description : ""}
                        placeholder="Product Meta Description"
                        onChange={this.handleChange}
                        name="offer_description"
                      />
                    </FormGroup>
                  </Col>
                  {(this.state.multi_lang == "yes") &&
                  <Col md={6} xs={12}>
                    <FormGroup controlId="formFrenchOfferMetaDescription:">
                      <ControlLabel>
                        Product Meta Description (Canadian French)
                      </ControlLabel>
                      <FormControl
                        type="text"
                        value={(this.state.french_offer_description) ? this.state.french_offer_description : ""}
                        placeholder="Product Meta Description (Canadian French)"
                        onChange={this.handleChange}
                        name="french_offer_description"
                      />
                    </FormGroup>
                  </Col>
                }
                </Row>
              </div>
            </div>
          </div>
          {/**end meta keywords **/}

          {/**start Offer Options **/}
          <div className="panel">
            <header className="panel-heading">
              Product Options
            </header>
            <div className="panel-body">
              <div className="add-city col-lg-12 col-md-12 col-sm-12 col-xs-12">
                <Row>
                  <Col md={6} xs={12}>
                    <FormGroup controlId="formwillCall">
                      <ControlLabel>
                        Does this product require pick up at Will Call?
                      </ControlLabel>
                      <FormControl
                        value={(this.state.willCall) ? this.state.willCall : ""}
                        onChange={this.handleChange}
                        componentClass="select"
                        name="willCall"
                        placeholder="select"
                      >
                        <option value="0">No</option>
                        <option value="1">Yes</option>
                      </FormControl>
                    </FormGroup>
                  </Col>
                  <Col md={6} xs={12}>
                    <FormGroup controlId="formshowPurchasedCount">
                      <ControlLabel>
                        Show Purchased Count?
                      </ControlLabel>
                      <FormControl
                        value={(this.state.showPurchasedCount) ? this.state.showPurchasedCount : ""}
                        onChange={this.handleChange}
                        componentClass="select"
                        name="showPurchasedCount"
                        placeholder="select"
                      >
                        <option value="0">No</option>
                        <option value="1">Yes</option>
                      </FormControl>
                    </FormGroup>
                  </Col>
                  <Col md={6} xs={12}>
                    <FormGroup controlId="formshowQuantityLeft">
                      <ControlLabel>
                        Show Quantity Left Count?
                      </ControlLabel>
                      <FormControl
                        value={(this.state.showQuantityLeft) ? this.state.showQuantityLeft : ""}
                        onChange={this.handleChange}
                        componentClass="select"
                        name="showQuantityLeft"
                        placeholder="select"
                      >
                        <option value="no">No</option>
                        <option value="yes">Yes</option>
                      </FormControl>
                    </FormGroup>
                  </Col>
                  <Col md={6} xs={12}>
                    <FormGroup controlId="formMarketingpixelurl">
                      <ControlLabel>Marketing pixel url</ControlLabel>
                      <FormControl
                        type="text"
                        value={(this.state.marketingPixelUrl) ? this.state.marketingPixelUrl : ""}
                        placeholder="Marketing pixel url"
                        onChange={this.handleChange}
                        name="marketingPixelUrl"
                      />
                    </FormGroup>
                  </Col>
                  <Col md={6} xs={12}>
                    <FormGroup controlId="formisPrivate">
                      <ControlLabel>Make This Product Private?</ControlLabel>
                      <FormControl
                        value={(this.state.isPrivate) ? this.state.isPrivate : ""}
                        onChange={this.handleChange}
                        componentClass="select"
                        name="isPrivate"
                        placeholder="select"
                      >
                        <option value="0">No</option>
                        <option value="1">Yes</option>
                      </FormControl>
                    </FormGroup>
                  </Col>
                  <Col md={6} xs={12}>
                    <FormGroup controlId="formproductPageUrl">
                      <ControlLabel>
                        Product page URL (overrides the merchant website url)
                      </ControlLabel>
                      <FormControl
                        type="text"
                        value={(this.state.productPageUrl) ? this.state.productPageUrl : ""}
                        placeholder="Product page URL"
                        onChange={this.handleChange}
                        name="productPageUrl"
                      />
                    </FormGroup>
                  </Col>
                  <Col md={6} xs={12}>
                    <FormGroup controlId="formproductHideLocation">
                      <ControlLabel>Hide Location Tab On Product Details Page?</ControlLabel>
                      <FormControl
                        value={(this.state.productHideLocation) ? this.state.productHideLocation : ""}
                        onChange={this.handleChange}
                        componentClass="select"
                        name="productHideLocation"
                        placeholder="select"
                      >
                        <option value="0">No</option>
                        <option value="1">Yes</option>
                      </FormControl>
                    </FormGroup>
                  </Col>
                </Row>
              </div>
            </div>
          </div>
          {/**end Offer Options **/}

          {/**start Order Options **/}
          <div className="panel">
            <header className="panel-heading">
              Order Options
            </header>
            <div className="panel-body">
              <div className="add-city col-lg-12 col-md-12 col-sm-12 col-xs-12">
                <Row>
                  <Col md={6} xs={12}>
                      <FormGroup controlId="formRedeemedAtCall">
                        <ControlLabel>
                          {/*Will vouchers be redeemed at will call?*/}
                          Allow this product to be Gifted?
                        </ControlLabel>
                        <FormControl
                          componentClass="select"
                          name="redeemedAtCall"
                          onChange={this.handleChange}
                          value={(this.state.redeemedAtCall) ? this.state.redeemedAtCall : ""}
                        >
                          <option value="0">No</option>
                          <option value="1">Yes</option>
                        </FormControl>
                      </FormGroup>                      
                  </Col>
                  <Col md={6} xs={12}>
                    <FormGroup controlId="formcheckoutNotes">
                      <ControlLabel>
                        Checkout Notes (shows up at the top of Checkout page)
                      </ControlLabel>
                      <FormControl
                        type="text"
                        value={(this.state.checkoutNotes) ? this.state.checkoutNotes : ""}
                        placeholder="Checkout Notes"
                        onChange={this.handleChange}
                        name="checkoutNotes"
                      />
                    </FormGroup>
                  </Col>
                  {(this.state.multi_lang == "yes") &&
                  <Col md={6} xs={12}>
                    <FormGroup controlId="formfrenchcheckoutNotes">
                      <ControlLabel>
                        Checkout Notes (shows up at the top of Checkout page in Canadian French)
                      </ControlLabel>
                      <FormControl
                        type="text"
                        value={(this.state.french_checkoutNotes) ? this.state.french_checkoutNotes : ""}
                        placeholder="Checkout Notes"
                        onChange={this.handleChange}
                        name="french_checkoutNotes"
                      />
                    </FormGroup>
                  </Col>
                  }
                  <Col md={6} xs={12}>
                    <FormGroup controlId="formAllowCouponCodes">
                      <ControlLabel>Allow promo codes on this product?</ControlLabel>
                      <FormControl
                        value={(this.state.allowCouponCodes) ? this.state.allowCouponCodes : ""}
                        onChange={this.handleChange}
                        componentClass="select"
                        name="allowCouponCodes"
                        placeholder="select"
                      >
                        <option value="0">No</option>
                        <option value="1">Yes</option>
                      </FormControl>
                    </FormGroup>
                  </Col>
                  <Col md={6} xs={12}>
                    <FormGroup controlId="formstoreCredit">
                      <ControlLabel>
                        Product is for store credit? (Disable use of store credit)
                      </ControlLabel>
                      <FormControl
                        value={(this.state.storeCredit) ? this.state.storeCredit : ""}
                        onChange={this.handleChange}
                        componentClass="select"
                        name="storeCredit"
                        placeholder="select"
                      >
                        <option value="0">No</option>
                        <option value="1">Yes</option>
                      </FormControl>
                    </FormGroup>
                  </Col>
                  <Col md={6} xs={12}>
                    <FormGroup controlId="formallowPaypal">
                      <ControlLabel>
                        Allow paypal payments for this product?
                      </ControlLabel>
                      <FormControl
                        value={(this.state.allowPaypal) ? this.state.allowPaypal : ""}
                        onChange={this.handleChange}
                        componentClass="select"
                        name="allowPaypal"
                        placeholder="select"
                      >
                        <option value="0">No</option>
                        <option value="1">Yes</option>
                      </FormControl>
                    </FormGroup>
                  </Col>
                </Row>
              </div>
            </div>
          </div>
          {/**end Order Options **/}          

          {/**start Taxes Options **/}
          <div className="panel">
            <header className="panel-heading">
              Taxes Options
            </header>
            <div className="panel-body">
              <div className="add-city col-lg-12 col-md-12 col-sm-12 col-xs-12">
                <Row>
                  <Col md={6} xs={12}>
                    <FormGroup controlId="formisTaxable">
                      <ControlLabel>Apply taxes to this product?</ControlLabel>
                      <FormControl
                        value={(this.state.isTaxable) ? this.state.isTaxable : ""}
                        onChange={this.handleChange}
                        componentClass="select"
                        name="isTaxable"
                        placeholder="select"
                      >
                        <option value="0">No</option>
                        <option value="1">Yes</option>
                      </FormControl>
                    </FormGroup>
                  </Col>
                  <Col md={6} xs={12}>
                    <FormGroup controlId="formuseMerchantDefaultTax">
                      <ControlLabel>
                        Use the Default Merchant Tax Rate (if NO the tax rate of the physical location will apply)
                      </ControlLabel>
                      <FormControl
                        value={(this.state.useMerchantDefaultTax) ? this.state.useMerchantDefaultTax : ""}
                        onChange={this.handleChange}
                        componentClass="select"
                        name="useMerchantDefaultTax"
                        placeholder="select"
                      >
                        <option value="0">No</option>
                        <option value="1">Yes</option>
                      </FormControl>
                    </FormGroup>
                  </Col>
                </Row>
              </div>
            </div>
          </div>
          {/**end Taxes Options **/}

          {/**start pause option **/}
          {/**end pause option **/}

          {/**start timer option **/}
          <div className="panel">
            <header className="panel-heading">Timer Options</header>
            <div className="panel-body">
              <div className="add-city col-lg-12 col-md-12 col-sm-12 col-xs-12">
                <Row>
                  <Col md={6} xs={12}>
                    <FormGroup controlId="formdisplayTimer">
                      <ControlLabel>
                        Display timer on the product ALWAYS?
                      </ControlLabel>
                      <FormControl
                        value={(this.state.displayTimer) ? this.state.displayTimer : ""}
                        onChange={this.handleChange}
                        componentClass="select"
                        name="displayTimer"
                        placeholder="select"
                      >
                        <option value="0">No</option>
                        <option value="1">Yes</option>
                      </FormControl>
                    </FormGroup>
                  </Col>
                  <Col md={6} xs={12}>
                    <FormGroup controlId="formtimerStartInHour">
                      <ControlLabel>
                        Timer Start before deal end in hours
                      </ControlLabel>
                      <FormControl
                        type="text"
                        value={(this.state.timerStartInHour) ? this.state.timerStartInHour : ""}
                        placeholder="Hours"
                        onChange={this.handleChange}
                        name="timerStartInHour"
                      />
                    </FormGroup>
                  </Col>
                </Row>
              </div>
            </div>
          </div>
          {/**end timer option **/}

          {/**start pause option **/}
          <div className="panel">
            <header className="panel-heading">Pause Options</header>
            <div className="panel-body">
              <div className="add-city col-lg-12 col-md-12 col-sm-12 col-xs-12">
                <Row>
                  <Col md={6} xs={12}>
                    <FormGroup controlId="formpaused">
                      <ControlLabel>Pause this product?</ControlLabel>
                      <FormControl
                        value={(this.state.paused) ? this.state.paused : ""}
                        onChange={this.handleChange}
                        componentClass="select"
                        name="paused"
                        placeholder="select"
                      >
                        <option value="0">No</option>
                        <option value="1">Yes</option>
                      </FormControl>
                    </FormGroup>
                  </Col>
                  <Col md={6} xs={12}>
                    <FormGroup controlId="formusePauseTimer">
                      <ControlLabel>Use a pause timer?</ControlLabel>
                      <FormControl
                        value={(this.state.usePauseTimer) ? this.state.usePauseTimer : ""}
                        onChange={this.handleChange}
                        componentClass="select"
                        name="usePauseTimer"
                        placeholder="select"
                      >
                        <option value="0">No</option>
                        <option value="1">Yes</option>
                      </FormControl>
                    </FormGroup>
                  </Col>
                </Row>
                {(this.state.usePauseTimer === "1" || this.state.usePauseTimer === 1) &&
                <Row>
                  <Col md={6} xs={12}>
                    <FormGroup controlId="formstartPauseDateTime">
                      <ControlLabel>Start Pause Date & Time</ControlLabel>
                      {this.state.startPauseDateTimeTooltipError && (
                        <Tooltip
                          placement="top"
                          style={{ marginTop: "-80px", marginLeft: "148px" }}
                          className="in"
                          id="tooltip-top"
                        >
                          {this.state.startPauseDateTimeTooltipError}
                        </Tooltip>
                      )}
                      <DateTimePicker
                        className={this.state.startPauseDateTimeError}
                        onChange={this.onChangeStartPauseDateTime}
                        value={(this.state.startPauseDateTime) ? this.state.startPauseDateTime : ''}
                      />
                    </FormGroup>
                  </Col>
                  <Col md={6} xs={12}>
                    <FormGroup controlId="formendPauseDateTime">
                      <ControlLabel>End Pause Date & Time</ControlLabel>
                      {this.state.endPauseDateTimeTooltipError && (
                        <Tooltip
                          placement="top"
                          style={{ marginTop: "-80px", marginLeft: "138px" }}
                          className="in"
                          id="tooltip-top"
                        >
                          {this.state.endPauseDateTimeTooltipError}
                        </Tooltip>
                      )}
                      <DateTimePicker
                        className={this.state.endPauseDateTimeError}
                        onChange={this.onChangeEndPauseDateTime}
                        value={(this.state.endPauseDateTime) ? this.state.endPauseDateTime : ""}
                      />
                    </FormGroup>
                  </Col>
                </Row>
                }
              </div>
            </div>
          </div>
          {/**end pause option **/}          

          <Row className="BtnRow">
            <Col md={12} xs={12}>
              {/*<Button
                bsStyle="info"
                type="submit"
                id="saveButton"
                disabled={this.state.disabled}
              >
                {this.state.submitValue}
              </Button>*/}
              {aclUtil.checkACL('EDIT_PRODUCTS_DETAILS') &&
                <Button
                  bsStyle="info"
                  type="submit"
                  id="schedule"
                  data-key="schedule"
                  disabled={this.state.disabled}
                  onClick={this.handleSubmit}
                >
                  Save / Schedule
                </Button>
              }
              {aclUtil.checkACL('PUBLISH_PRODUCTS') &&
                <Button
                  bsStyle="info"
                  type="submit"
                  id="execute"
                  data-key="publish"
                  disabled={this.state.disabled}
                  onClick={this.handleSubmit}
                >
                  Publish Product
                </Button>
              }
              <Button
                bsStyle="default"
                onClick={() => this.context.router.history.push(`/productList`)}
              >
                Cancel
              </Button>
            </Col>
          </Row>
        </form>
        <Modal show={this.state.openIamgeAttribute} onHide={this.closeAttribute.bind(this)} backdrop="static">
          <Modal.Header closeButton>
            <Modal.Title>Image Attribute</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Row>
              <Col md={6} xs={6}>
                <Image
                  src={this.state.attributeImg}
                  width="100%"
                  thumbnail
                />
              </Col>
              <Col md={6} xs={6}>
                <FormGroup controlId="formTitle">
                  <ControlLabel>
                    Title
                  </ControlLabel>
                  <FormControl
                    type="text"
                    value={(this.state.img_text !== 'null') ? this.state.img_text : ''}
                    placeholder="Title"
                    onChange={this.handleChange}
                    name="img_text"
                    style={{borderColor: this.state.img_textError}}
                  />
                </FormGroup>
                <FormGroup controlId="formTitle">
                  <ControlLabel>
                    Alt Text
                  </ControlLabel>
                  <FormControl
                    type="text"
                    value={(this.state.img_alt_text !== 'null') ? this.state.img_alt_text : ''}
                    placeholder="Alt Text"
                    onChange={this.handleChange}
                    name="img_alt_text"
                    style={{borderColor: this.state.img_alt_textError}}
                  />
                </FormGroup>
                <FormGroup controlId="formTitle">
                  <ControlLabel>
                    Description
                  </ControlLabel>
                  <FormControl
                    type="text"
                    value={(this.state.img_desc !== 'null') ? this.state.img_desc : ''}
                    placeholder="Description"
                    onChange={this.handleChange}
                    name="img_desc"
                    style={{borderColor: this.state.img_descError}}
                  />
                </FormGroup>
              </Col>
            </Row>
          </Modal.Body>
          <Modal.Footer>
            <Button bsStyle="success" onClick={this.saveImageAttribute}>
              Save
            </Button>
            <Button bsStyle="danger" onClick={this.closeAttribute.bind(this)}>
              Close
            </Button>
          </Modal.Footer>
        </Modal>
        <Modal show={this.state.crompImagePopup} onHide={this.closeCropPopup.bind(this)} backdrop="static">
          <Modal.Header closeButton>
            <Modal.Title>Crop Image</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Row>
              <Col md={12} xs={12}>
                <span className="text-danger">Croped Image Size: <b>{this.state.imgWidth}px</b> X <b>{this.state.imgHeight}px</b></span>
              </Col>
              <Col md={12} xs={12}>
                {this.state.src && (
                  <ReactCrop
                    src={this.state.src}
                    crop={this.state.crop}
                    onImageLoaded={this.onImageLoaded}
                    onComplete={this.onCropComplete}
                    onChange={this.onCropChange}
                  />
                )}
              </Col>
              <Col md={12} xs={12}>
                {croppedImageUrl && (
                  <img alt="Crop" style={{ maxWidth: '100%' }} src={croppedImageUrl} />
                )}
              </Col>
            </Row>
          </Modal.Body>
          <Modal.Footer>
            <Button bsStyle="success" onClick={this.saveCropImage}>
              Save
            </Button>
            <Button bsStyle="danger" onClick={this.closeCropPopup.bind(this)}>
              Close
            </Button>
          </Modal.Footer>
        </Modal>
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    dealDetail: state.dealReducer.dealDetail,
    catList: state.categoryReducer.catData,
    editDeal: state.dealReducer.editDeal,
    error: state.dealReducer.error,
    categoryError: state.categoryReducer.error,
    dealLoc: state.dealReducer.dealLoc,
    destroyImage: state.dealReducer.destroyImage,
    merchantLocationDetails: state.merchantReducer.merchantLocationDetails,
    alertType: state.alertsReducer.alertType,
    message: state.alertsReducer.message,
    attributeStatus: state.dealReducer.attributeStatus,
    imageStatus: state.dealReducer.imageStatus,
    cityList: state.frontReducer.cityList,
  };
};

export default compose(
  withRouter, // IMPORTANT: witRouter is "needed here" to avoid blocking routing:
  connect(mapStateToProps, {
    getDealDetail,
    deleteImage,
    getAllCategory,
    editProductList,
    get_merchant_location_details,
    addDealLocation,
    renderAlert,
    clearAlert,
    updateAttribute,
    uploadImage,
    updateDealImgOrdering,
    getSiteCity
  })
)(EditProduct);



// WEBPACK FOOTER //
// ./src/app/views/admin/product/EditProduct.js